// TDS2 SHIM — replace with @salesforce/trailhead-ui ThinkingSummaryDisclosure when TDS2 lands.
// Mirrors the prototype's `ThinkingTraceDisclosure`
// (headless-agent-creation/src/pages/UnitBuildAgent.tsx).
//
// Rendered above an assistant message once its thinking phase has finished:
// a chevron + summary line that, when clicked, expands an ordered list of
// the thinking steps the agent went through. Collapsed by default so the
// final answer stays the focus.
import React from 'react';
import PropTypes from 'prop-types';

function Chevron({ open }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={
        'tds2-agentforce-thinking__caret' +
        (open ? ' tds2-agentforce-thinking__caret--open' : '')
      }
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

Chevron.propTypes = { open: PropTypes.bool.isRequired };

export default class ThinkingSummaryDisclosure extends React.Component {
  static propTypes = {
    summary: PropTypes.string.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  state = { open: false };

  toggle = () => {
    this.setState((prev) => ({ open: !prev.open }));
  };

  render() {
    const { summary, steps } = this.props;
    const { open } = this.state;

    return (
      <div className="tds2-agentforce-thinking__summary">
        <button
          type="button"
          className="tds2-agentforce-thinking__summary-button"
          onClick={this.toggle}
          aria-expanded={open}
        >
          <Chevron open={open} />
          <span>{summary}</span>
        </button>
        {open ? (
          <ol className="tds2-agentforce-thinking__summary-list">
            {steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        ) : null}
      </div>
    );
  }
}
